/**
 * Screen 3 — Enrollment Split.
 *
 * Desktop (≥ 992px): renders the prospect's enrollment page inside an iframe
 *                    in the right pane, alongside the live Zoom embed.
 * Mobile (< 992px):  opens the enrollment page in a new browser tab so Zoom
 *                    stays in the original tab. The split layout is never
 *                    used; this component renders a brief confirmation only.
 *
 * URL assembly uses the shared util in src/shared/utilities/enrollmentUrl.function.js
 * with the verify-endpoint payload (recruiterId, uplineId, uplineLogin, com_code,
 * prefillData).
 */

import React from 'react'
import Store from './../../RecruitingMeetingPage.store'
import { buildEnrollmentUrl } from './../../../../shared/utilities/enrollmentUrl.function'

import './EnrollmentSplit.component.scss'

const DESKTOP_MIN_WIDTH = 992

class EnrollmentSplit extends React.Component {
  state = {
    isDesktop: typeof window !== 'undefined' && window.innerWidth >= DESKTOP_MIN_WIDTH,
    mobileOpened: false,
  }

  _resizeHandler = null

  componentDidMount() {
    this._resizeHandler = () => {
      this.setState({ isDesktop: window.innerWidth >= DESKTOP_MIN_WIDTH })
    }
    window.addEventListener('resize', this._resizeHandler)

    if (!this.state.isDesktop) {
      this.openMobile()
    }
  }

  componentWillUnmount() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler)
      this._resizeHandler = null
    }
  }

  buildUrl = () => {
    const ctx = Store.meetingContext || {}
    if (!ctx.uplineLogin) return null
    return buildEnrollmentUrl({
      uLogin: ctx.uplineLogin,
      recruiterId: ctx.recruiterId,
      uplineId: ctx.uplineId,
      // commissionId (verify response) → comCode (URL query param).
      // The URL param name is `com_code` for back-compat with
      // EnrollmentLinkCreator, even though it actually carries an id.
      comCode: ctx.commissionId,
      prefillData: ctx.prefillData,
      hideHeader: true,
      hideFooter: true,
    })
  }

  openMobile = () => {
    const url = this.buildUrl()
    if (!url) return
    window.open(url, '_blank', 'noopener')
    this.setState({ mobileOpened: true })
  }

  render() {
    const url = this.buildUrl()

    if (!url) {
      return (
        <div className='rm-enroll'>
          <div className='rm-enroll__error'>
            <p>Your enrollment link is being prepared.</p>
            <small>If this persists, please contact your recruiter.</small>
          </div>
        </div>
      )
    }

    if (!this.state.isDesktop) {
      return (
        <div className='rm-enroll'>
          <div className='rm-enroll__mobile'>
            <p>Your enrollment page is open in a new tab.</p>
            <button type='button' className='rm-enroll__mobile-reopen' onClick={this.openMobile}>
              Reopen Enrollment Page
            </button>
          </div>
        </div>
      )
    }

    return (
      <div className='rm-enroll'>
        <iframe className='rm-enroll__frame' title='USABG Enrollment' src={url} referrerPolicy='origin' />
      </div>
    )
  }
}

export default EnrollmentSplit
